import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'projects-task-input-selector-button',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './projects-task-input-selector-button.component.html',
  styleUrl: './projects-task-input-selector-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsTaskInputSelectorButtonComponent {
  @Input() isSelected: boolean = false;
  @Input() rightContainerText: string = '';
  @Input() inputControl!: FormControl;
  @Input() newTask: boolean = false;

  @Output() buttonClick = new EventEmitter<void>();

  @ViewChild('inputElement') inputElement!: ElementRef<HTMLInputElement>;

  onButtonClick() {
    this.inputElement.nativeElement.focus();
    this.buttonClick.emit();
  }

  onInputChange(value: number) {
    this.inputControl.setValue(Number(value));
  }

  onInputBlur() {
    const value = this.inputControl.value;
    if (value < 1) {
      this.inputControl.setValue(1);
    }
    if (!Number.isInteger(value)) {
      this.inputControl.setValue(Math.round(value));
    }
  }
}
